import type { CheckoutV2LoyaltyChoice } from "@jti/store/slices/checkoutV2Slice";

export type UserSelection = {
  loyaltyChoice: CheckoutV2LoyaltyChoice;
  cartId: string;
};
